/**
 * Kyrgyz phone numbers on 06 (D-73). The field shows a fixed «+996» and the
 * master types the 9 digits after it. A pasted «0700…», «996700…» or
 * «+996 700…» loses the extra prefix, so the card never says «+996 0700…».
 */

/** The 9 local digits from whatever was typed or pasted: «0700 98 76 54» -> «700987654». */
export function localDigits(input: string): string {
  let d = input.replace(/\D/g, '');
  if (d.length > 9 && d.startsWith('996')) d = d.slice(3);
  if (d.startsWith('0')) d = d.slice(1);
  return d.slice(0, 9);
}

/** «700987654» -> «700 98-76-54», also while it is still being typed. */
export function groupLocal(digits: string): string {
  const parts = [digits.slice(0, 3), digits.slice(3, 5), digits.slice(5, 7), digits.slice(7, 9)].filter(Boolean);
  return parts.length ? [parts[0], parts.slice(1).join('-')].filter(Boolean).join(' ') : '';
}

/** What the client card stores: «+996 700 98-76-54», or null when nothing was typed. */
export function fullPhone(digits: string): string | null {
  return digits ? `+996 ${groupLocal(digits)}` : null;
}
